import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/**
 * A 401 means the Tahiti token is dead — retrying just delays the redirect
 * session-expiry.ts already triggers on the first attempt. Every other
 * error keeps the previous retry:1 behavior.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status === 401) return false;
  return failureCount < 1;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: shouldRetryQuery,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
